<template>
    <div class="certifi-brochure-wrap">
        <a
            class="brochure-btn"
            href="/brochure/certified-cics-cip2.pdf"
            download="한국내부통제협회 자격증 소개브로슈어.pdf"
        >
            <i class="fa-solid fa-download brochure-icon" aria-hidden="true"></i>
            Brochure 다운로드
        </a>
    </div>

    <section class="cics">
        <div class="cics__inner">
            <h2 class="cics__title">
                <strong>Certified Internal Control Specialist<br />CICS 국제공인 내부통제사</strong>
            </h2>
            <p>
                &nbsp;CICS(Certified Internal Control Specialist)는 국제내부통제협회(ICI, Internal Control Institute)가 주관하고,
                한국내부통제협회(ICIK)가 공식 대행하는 국제공인 내부통제 전문 자격입니다.<br />
                이 자격은 내부통제 공통지식체계(CBOK, Common Body of Knowledge)에 기반하여,
                국제 기준에 맞춰 제도화된 통제장치가 올바르게 실행되도록 실질적인 내부통제 역량을 검증하고,<br />
                조직 내 통제 시스템의 설계·운영·평가 역량을 공식적으로 인증합니다.<br />
                &nbsp;또한 CICS는 <strong>내부통제 분야에서 고급 수준의 전문성을 갖춘 전문가에게 부여되는 인증</strong>으로,
                응시자는 ICI 인증위원회가 정한 폭넓은 기술과 지식 요건을 충족해야 합니다.<br />
                시험은 온라인으로 진행되며, 내부통제 공통지식체계(CBOK)에 대한 이해도를 평가합니다.<br />
                &nbsp;CICS 자격의 핵심은 <strong>CBOK 각 분야에서의 실제 전문 경력과 실무 적용 능력</strong>으로,
                응시자의 경력과 활동이 명확히 검증되어야 최종적으로 자격이 부여됩니다.
            </p>
        </div>
    </section>

    <section class="course-steps-sec2">
        <h2 class="section-title-sec2">CICS 인증 절차</h2>

        <div class="step-sec2">
            <h3 class="step-title-sec2">1단계: 과정 등록 </h3>
            <img src="@/assets/CICS1.jpeg" alt="Registration Form" class="step-img-sec2" />
            <ul class="step-list-sec2">
                <li>ICI Korea 홈페이지에서 CICS 교육과정 세부 내용 확인</li>
                <li>등록 신청서 작성 (인적사항 및 직무 정보 입력)</li>
                <li>교육 일정 및 장소는 개별 안내</li>
            </ul>
        </div>

        <div class="step-sec2">
            <h3 class="step-title-sec2">2단계: 교육 준비 </h3>
            <img src="@/assets/CICS2.jpeg" alt="Training Preparation" class="step-img-sec2" />
            <ul class="step-list-sec2">
                <li>협회에서 제공하는 사전 학습자료를 검토</li>
                <li>내부통제 핵심 개념 및 CBOK 주요 항목 숙지</li>
            </ul>
        </div>

        <div class="step-sec2">
            <h3 class="step-title-sec2">3단계: 인증 시험 응시 </h3>
            <img src="@/assets/certificatoin3.jpeg" alt="Certification Exam" class="step-img-sec2" />
            <ul class="step-list-sec2">
                <li>교육과정 수료 후 CICS 시험 등록</li>
                <li>시험 준비자료 및 실무사례 복습</li>
            </ul>
        </div>
    </section>

    <section class="why-cics">
        <div class="why-cics__inner">
            <!-- 왼쪽: 문구 -->
            <div class="why-cics__text">
                <h3 class="why-cics__title">왜 CICS인가?</h3>
                <p>
                    CICS는 글로벌 내부통제 기준인 COSO 내부통제 프레임워크에 부합하는 전문가 자격으로<br/> 강화되는 내부통제 평가와 변화하는 환경에 대응할 수 있는 글로벌 실무 역량을 확보하도록 <br/>설계되었습니다.
                </p>
                <p>
                    또한, 단순한 이론 습득을 넘어 실제 내부통제 수행 능력을 검증하며, 내부통제 원칙과<br/> 리스크 관리 등 8개 핵심역량 평가 체계를 통해 체계적 전문성을 함양합니다. 
                </p>
                <p>
                    CICS를 통해 개인은 국제적 경쟁력을 갖춘 내부통제 전문가로 성장하고, 조직은 신뢰성과<br/> 투명성을 강화하여 지속가능한 경영체계를 구축할 수 있습니다.
                </p>
            </div>

            <!-- 오른쪽: 설명 이미지 -->
            <div class="why-cics__image">
                <img src="@/assets/CICS-pic.png" alt="CICS 설명 다이어그램" />
            </div>
        </div>
    </section>

    <!-- section3 -->
    <div class="eligible-bg-sec3">
        <div class="eligible-container-sec3">
            <h2 class="eligible-title-sec3">
                지원 자격
            </h2>
            <div class="eligible-content-sec3">
                <div class="eligible-image-sec3"></div>
                <div class="eligible-text-sec3">
                    <p>
                        CICS는 내부감사, 준법감시, 리스크관리, 재무통제, 지배구조 등 관련 분야 전문가를 위한<br/> 자격으로, 내부통제 공통지식체계(Common Body of Knowledge,
                        CBOK)에 대한 충분한 이해와 아래 요건 중 하나를 충족해야 합니다.
                    </p>
                    <!-- <div class="eligible-req-title-sec3">자격 요건</div> -->
                    <div class="eligible-option-sec3">
                        <div class="eligible-option-header">Option 1</div>
                        <ul class="eligible-list-sec3">
                            <li>회계, 금융, 감사, 경영, 법무, 리스크관리 등 관련 분야의 학사 이상 학위 보유자</li>
                            <li>3년 이상 내부통제 실무경력</li>
                        </ul>
                    </div>

                    <div class="eligible-option-sec3">
                        <div class="eligible-option-header">Option 2</div>
                        <ul class="eligible-list-sec3">
                            <li>5년 이상 내부통제 실무경력 (학위 요건 없음)</li>
                        </ul>
                    </div>
                    <p>※ 자격 요건 미충족자도 시험 응시는 가능하며, 추후 요건 충족 시 자격 부여</p>
                    <!-- <div href="#" class="eligible-link-sec3">CLICK FOR MORE INFORMATION</div> -->
                </div>
            </div>
        </div>
    </div>

    <section class="fee">
        <div class="fee__head">
            <h2 class="fee__title">자격인증 비용</h2>
            <!-- <p class="fee__note">※ 환율에 따라 비용은 변동될 수 있습니다. (VAT 포함)</p> -->
            <p class="fee__note">※ 환율에 따라 비용은 변동될 수 있습니다.</p>
        </div>

        <!-- 표 (Grid) -->
        <div class="fee__table" role="table" aria-label="자격인증 비용 표">
            <!-- 헤더 -->
            <div class="fee__row fee__row--head" role="row">
                <div class="fee__cell" role="columnheader">자격증 비용</div>
                <div class="fee__cell" role="columnheader">ICI 회원</div>
                <div class="fee__cell" role="columnheader">ICI 비회원</div>
            </div>
            <!-- 데이터 -->
            <div class="fee__row" role="row">
                <div class="fee__cell" role="cell">CICS 국제공인 내부통제사</div>
                <!-- <div class="fee__cell fee__price" role="cell">550,000원</div>
                <div class="fee__cell fee__price" role="cell">660,000원</div> -->
                <div class="fee__cell fee__price" role="cell">
                {{ memberPrice ? memberPrice.toLocaleString() + '원' :  hardMemberPrice.toLocaleString() + '원' }}
                </div>

                <div class="fee__cell fee__price" role="cell">
                {{ nonMemberPrice ? nonMemberPrice.toLocaleString() + '원' :  hardnonMemberPrice.toLocaleString() + '원' }}
                </div>
            </div>
        </div>

        <p class="fee__footnote">※ 합격기준 : 총 96문항(75분간 실시) 중 75점 이상 취득</p>
    </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { exchange } from "@/api/license"; // 이미 만들어둔 API

// 환율 & 계산된 금액
const rate = ref(null);
const memberPrice = ref(null);
const nonMemberPrice = ref(null);

// 금액 포맷터
const format = (value) => value.toLocaleString() + "원";

// 10시 이전에 api가 조회가 되지 않아서 하드코딩으로 환율을 적용했음
const hardMemberPrice = Math.round(300 * 1500 + 130000)
const hardnonMemberPrice = Math.round(300 * 1500 + 240000)

// onMounted(async () => {
//   try {
//     const res = await exchange(); // API 호출
//     const fx = Number(res.dealBasR.replace(/,/g, "")); // "1,471.5" → 1471.5

//     rate.value = fx;

//     // 계산식 적용
//     memberPrice.value = Math.round(300 * fx + 130000);
//     nonMemberPrice.value = Math.round(300 * fx + 240000);

//   } catch (e) {
//     console.error("환율 조회 실패", e);
//   }
// });

onMounted(async () => {
  try {
    const res = await exchange();

    console.log("환율 응답:", res);

    const rawRate = res?.dealBasR;

    if (!rawRate) {
      console.warn("환율 데이터 없음", res);
      return;
    }

    const fx = Number(String(rawRate).replace(/,/g, ""));

    rate.value = fx;

    memberPrice.value = Math.round(300 * fx + 130000);
    nonMemberPrice.value = Math.round(300 * fx + 240000);

  } catch (e) {
    console.error("환율 조회 실패", e);
  }
});
</script>

<style scoped src="./Cics.css"></style>